module.exports = __webpack_public_path__ + "s/img/Flower@2x.e330aee0.png";